import { Environment } from 'shared/enums/environments.js';

export const environment: Environment = getEnvironment();

function getEnvironment(): Environment {
  if (typeof window === 'undefined') return Environment.Prod;
  const { hostname } = window.location;

  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    return Environment.Local;
  }
  if (
    hostname.includes('biodiversity-dev.alveole.buzz') ||
    hostname.includes('myhive-dev.alveole.buzz') ||
    hostname.includes('maruche-dev.alveole.buzz')
  ) {
    return Environment.Dev;
  }
  if (
    hostname.includes('biodiversity.alveole.buzz') ||
    hostname.includes('myhive.alveole.buzz') ||
    hostname.includes('maruche.alveole.buzz')
  ) {
    return Environment.Prod;
  }
  if (hostname.includes('aura.alveole.com')) {
    return Environment.SSG;
  }
  throw Error(`Unknown environment for hostname: ${hostname}`);
}
